// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  authSettings: {
    clientId: 'b4e83d89-d3fb-405a-b78e-d5b66a6d3958',
    tenant: 'connectedbuildingsUae.onmicrosoft.com',
    expireOffsetSeconds: 3000,
    endpoints: {
      'https://cblduaeprodapims.azure-api.net/portal/v1/api/': 'https://connectedbuildingsUae.onmicrosoft.com/adminportaluaeprodapi/'
    },
    ocpApimSubscriptionKey: '55ae0179b62f4c9e9b30cf333a16f19c',
    organizationId: '',
    getRoleUrl: 'https://cblduaeprodapims.azure-api.net/portal/v1/api/User/RolesAndPrivileges/',
    getRoleResource: 'https://connectedbuildingsUae.onmicrosoft.com/adminportaluaeprodapi/',
  },
  orgSettingsApiUrl: 'https://cblduaeprodapims.azure-api.net/portal/v1/api/Settings',
  orgPresalesSettingsApiUrl: 'https://cblduaeprodapims.azure-api.net/portal/v1/api/PresalesSettings',
  fileUploadUrl: 'https://cblduaeprodapims.azure-api.net/portal/v1/api/file/upload',
  fileContentUrl: 'https://cblduaeprodapims.azure-api.net/portal/v1/api/file/content',
  ocpApimSubscriptionKey: '55ae0179b62f4c9e9b30cf333a16f19c',
  dmsPortalUrl: 'https://honeywellprod.sharepoint.com/teams/OBS-DMS/SitePages/Home.aspx',
  CORToolUrl: 'https://honeywellprod.sharepoint.com/:f:/r/teams/OBS-DMS/OBS%20Project%20Files/ProcessDocuments%26Tools/EBI%20-%20OBS%20Site%20Information%20Gathering%20Tool',
  gatewayTenantAccountApiUrl: 'https://fc.api.gatewaymgr.ae.honeywellforge.com/api/tenants',
  gatewayManagerAPIKongAuthKey: 'vPuSgdqd6LZo4p8JMdNLbi7QGEvWXw9Y',
  cdt: {
    api_url: 'https://papi.honeywellforge.ae/modeleditor-api/',
    ttl: 15,
    refreshInterval: 25000
  },
  historyValidation: {
    historyValidationServiceUrl: 'https://cblduaeprodapims.azure-api.net/portal/v1/api/history-validation/',
    historyValidationOcpApimSubscriptionKey: '55ae0179b62f4c9e9b30cf333a16f19c'
  },
  eventLogger: {
    api_url: 'https://prod-cbld-adminportal-onboardingworkflowapi.platform.honeywellforge.ae/api/'
  },
  launchDarklyClientId: '58f89a9f5a64a10a1bc8aae1',
  launchDarklyUserKey: 'sdk-32de31b6-c8ca-4bdf-9d1a-71e0012db129'
};
